import React from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navigation = ({ authToken, userType, onLogout }) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  return (
    <nav style={{ backgroundColor: '#ffffff', color: '#003d66' }} className="shadow-md border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2">
            <img
              src="/logo.png"
              alt="CoSpace Logo"
              className="h-10 w-auto object-contain block"
            />
            <span className="text-2xl font-bold">CoSpace</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/spaces" className="hover:text-[#2563eb] transition">Find Spaces</Link>
            {authToken ? (
              <>
                <Link to="/dashboard" className="hover:text-[#2563eb] transition">Dashboard</Link>
                <button onClick={onLogout} style={{ backgroundColor: '#2563eb', color: '#ffffff' }} className="px-4 py-2 rounded transition hover:opacity-90">
                  Logout
                </button>
              </>
            ) : (
              <Link to="/auth" style={{ backgroundColor: '#2563eb', color: '#ffffff' }} className="px-4 py-2 rounded transition hover:opacity-90">
                Login / Register
              </Link>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden">
            {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden pb-4 space-y-2 text-[#003d66]">
            <Link to="/spaces" className="block py-2 hover:text-[#2563eb]" onClick={() => setIsMenuOpen(false)}>
              Find Spaces
            </Link>
            {authToken ? (
              <>
                <Link to="/dashboard" className="block py-2 hover:text-[#2563eb]" onClick={() => setIsMenuOpen(false)}>
                  Dashboard
                </Link>
                <button onClick={() => { onLogout(); setIsMenuOpen(false); }} style={{ color: '#2563eb' }} className="block w-full text-left py-2 hover:opacity-70">
                  Logout
                </button>
              </>
            ) : (
              <Link to="/auth" style={{ color: '#2563eb' }} className="block py-2 hover:opacity-70" onClick={() => setIsMenuOpen(false)}>
                Login / Register
              </Link>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
